// extracted by mini-css-extract-plugin
export default {"contentSpinner":"Loading_contentSpinner__0oCW5","rowSpinner":"Loading_rowSpinner__uNKzj"};